var stripeReadonlyProfileMixin = {
  data () {
    return {
      stripeSetupIntentClientSecret: ""
    };
  }
};

export { stripeReadonlyProfileMixin as default };
